module.exports = __webpack_public_path__ + "img/img_vipprice.55b20ca0.png";